import {createQueryKeys} from "../../shared/query/query-keys";

export const supplierFunctionKeys = createQueryKeys("supplierFunctions");

export const supplierFunctionMutationKeys = {
  createSupplierFunction: ["supplierFunctions", "mutation", "create-supplier-function"] as const,
  updateSupplierFunction: ["supplierFunctions", "mutation", "update-supplier-function"] as const,
  deleteSupplierFunction: ["supplierFunctions", "mutation", "delete-supplier-function"] as const,
  restoreSupplierFunction: ["supplierFunctions", "mutation", "restore-supplier-function"] as const,
} as const;
